import ims from '../../imports';

export default {
  getMember: function ({ memberId }) {
    return ims.axios({
      method: 'get',
      headers: {
        Authorization: 'Bearer ' + ims.firebase_auth.getAccessToken(),
      },
      baseURL: ims.config.api.prefix,
      url: `/members/${memberId}`,
      responseType: 'json',
      timeout: 1000 * 5,
    });
  },
};
